import { mapState, mapActions } from 'vuex'
const gSetPermissions = 'gSetPermissions'

export default {
  computed: {
    ...mapState({
      gPermissions: state => state.gPermissions.permissions
    })
  },
  methods: {
    ...mapActions([
      gSetPermissions
    ]),
    gRac (code) {
      return this.gPermissions.find(item => item.code === code)
    }
  }
}
